"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgEventDeadlineOptions = exports.OrgEventParentAttendancePermission = exports.OrgEventAttendancePermission = exports.OrgEventStatus = exports.OrgRefType = exports.OrgEventType = exports.OrgEventInterval = void 0;
var OrgEventInterval;
(function (OrgEventInterval) {
    OrgEventInterval[OrgEventInterval["UNSET"] = 0] = "UNSET";
    OrgEventInterval[OrgEventInterval["WEEKLY"] = 1] = "WEEKLY";
    OrgEventInterval[OrgEventInterval["BIWEEKLY"] = 2] = "BIWEEKLY";
    OrgEventInterval[OrgEventInterval["MONTHLY"] = 3] = "MONTHLY";
    OrgEventInterval[OrgEventInterval["YEARLY"] = 4] = "YEARLY";
})(OrgEventInterval = exports.OrgEventInterval || (exports.OrgEventInterval = {}));
var OrgEventType;
(function (OrgEventType) {
    OrgEventType[OrgEventType["DEFAULT"] = 0] = "DEFAULT";
    OrgEventType[OrgEventType["MEETING"] = 1] = "MEETING";
    OrgEventType[OrgEventType["VOLUNTARY_WORK"] = 2] = "VOLUNTARY_WORK";
    OrgEventType[OrgEventType["CALENDAR_ASSIGNMENT"] = 3] = "CALENDAR_ASSIGNMENT";
    OrgEventType[OrgEventType["TASK"] = 4] = "TASK";
    OrgEventType[OrgEventType["INSTRUCTION"] = 5] = "INSTRUCTION";
})(OrgEventType = exports.OrgEventType || (exports.OrgEventType = {}));
var OrgRefType;
(function (OrgRefType) {
    OrgRefType[OrgRefType["ORG"] = 0] = "ORG";
    OrgRefType[OrgRefType["MEETING"] = 1] = "MEETING";
})(OrgRefType = exports.OrgRefType || (exports.OrgRefType = {}));
var OrgEventStatus;
(function (OrgEventStatus) {
    OrgEventStatus[OrgEventStatus["ACTIVE"] = 0] = "ACTIVE";
    OrgEventStatus[OrgEventStatus["COMPLETED"] = 1] = "COMPLETED";
    OrgEventStatus[OrgEventStatus["DELETED"] = 2] = "DELETED";
    OrgEventStatus[OrgEventStatus["DRAFT"] = 3] = "DRAFT";
})(OrgEventStatus = exports.OrgEventStatus || (exports.OrgEventStatus = {}));
var OrgEventAttendancePermission;
(function (OrgEventAttendancePermission) {
    OrgEventAttendancePermission[OrgEventAttendancePermission["SET_AND_REMOVE"] = 0] = "SET_AND_REMOVE";
    OrgEventAttendancePermission[OrgEventAttendancePermission["SET_AND_NOT_REMOVE"] = 1] = "SET_AND_NOT_REMOVE";
    OrgEventAttendancePermission[OrgEventAttendancePermission["NOT_SET_AND_REMOVE"] = 2] = "NOT_SET_AND_REMOVE";
    OrgEventAttendancePermission[OrgEventAttendancePermission["NOT_SET_AND_NOT_REMOVE"] = 3] = "NOT_SET_AND_NOT_REMOVE";
})(OrgEventAttendancePermission = exports.OrgEventAttendancePermission || (exports.OrgEventAttendancePermission = {}));
var OrgEventParentAttendancePermission;
(function (OrgEventParentAttendancePermission) {
    OrgEventParentAttendancePermission[OrgEventParentAttendancePermission["NO_PARENTS"] = 0] = "NO_PARENTS";
    OrgEventParentAttendancePermission[OrgEventParentAttendancePermission["ALLOW_PARENTS"] = 1] = "ALLOW_PARENTS";
})(OrgEventParentAttendancePermission = exports.OrgEventParentAttendancePermission || (exports.OrgEventParentAttendancePermission = {}));
exports.OrgEventDeadlineOptions = [
    { title: 'event:deadline:end', value: null },
    { title: 'event:deadline:start', value: 1 },
    { title: 'event:deadline:hour_before', value: 60 },
    { title: 'event:deadline:hour_before_plural', value: 120 },
    { title: 'event:deadline:hour_before_plural', value: 180 },
    { title: 'event:deadline:hour_before_plural', value: 240 },
    { title: 'event:deadline:hour_before_plural', value: 300 },
    { title: 'event:deadline:hour_before_plural', value: 360 },
    { title: 'event:deadline:hour_before_plural', value: 720 },
    { title: 'event:deadline:hour_before_plural', value: 1440 },
];
//# sourceMappingURL=event.js.map